module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-cascader', {
    staticClass: "smart-cascader",
    attrs: {
      "options": _vm.optionsTree,
      "show-all-levels": false,
      "change-on-select": !_vm.onlySelectLeaf,
      "clearable": true,
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.changeValue
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c106786","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SmartForm/SmartFormItem/SmartCascader.vue
// module id = 1773
// module chunks = 1